// C1 - Ünite 2: Third Conditional
// Hedef: If + past perfect, would have + V3 (geçmiş pişmanlıklar)

export const C1_UNIT_2 = {
  'C1-U2-L1': {
    id: 'C1-U2-L1',
    title: 'If + Past Perfect, Would have + V3',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Third Conditional',
          explanation: 'Geçmişte gerçekleşmemiş durumlar ve varsayımlar için kullanılır. "Keşke... olsaydı, ...olurdu" anlamı taşır.',
          table: {
            headers: ['Yapı', 'Örnek', 'Anlam'],
            rows: [
              ['If + Past Perfect, would have + V3', 'If I had studied, I would have passed.', 'Çalışsaydım geçerdim (ama çalışmadım)'],
              ['Would have + V3 + if + Past Perfect', 'I would have helped if you had asked.', 'Sorsaydın yardım ederdim'],
              ['Could have / Might have', 'She could have been injured if...', 'Yaralanabilirdi eğer...'],
              ['Olumsuz', 'If I hadn\'t seen it, I wouldn\'t have believed it.', 'Görmeseydim inanmazdım']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Third Conditional = Geçmişe dair pişmanlık veya varsayım. Gerçekleşmemiş durumları anlatır.'
        },
        {
          type: 'example',
          title: '✈️ Havacılık Senaryoları',
          items: [
            { en: 'If the crew had noticed earlier, they would have prevented the incident.', tr: 'Ekip daha önce fark etseydi, olayı önlerdi.' },
            { en: 'The flight wouldn\'t have been cancelled if the weather had been better.', tr: 'Hava daha iyi olsaydı uçuş iptal edilmezdi.' },
            { en: 'If I had checked the manifest, I would have known about the VIP.', tr: 'Manifesto kontrol etseydim VIP\'i bilirdim.' }
          ]
        }
      ],
      exercises: [
        {
          type: 'swipeVocabulary',
          title: '🎴 Third Conditional Kalıpları',
          cards: [
            { front: 'If I had known...', back: 'Bilseydim...', example: 'If I had known, I would have told you.' },
            { front: 'would have been', back: 'olurdu', example: 'It would have been better.' },
            { front: 'could have happened', back: 'olabilirdi', example: 'Anything could have happened.' },
            { front: 'might have missed', back: 'kaçırabilirdi', example: 'She might have missed the flight.' },
            { front: 'wouldn\'t have', back: 'yapmazdı/olmazdı', example: 'I wouldn\'t have agreed.' },
            { front: 'If only I had...', back: 'Keşke ... olsaydı', example: 'If only I had listened!' }
          ]
        },
        {
          type: 'multipleChoice',
          question: 'If the passenger ___ the safety demonstration, she would have known what to do.',
          options: ['watched', 'had watched', 'has watched', 'would watch'],
          correctIndex: 1,
          explanation: 'Third Conditional için "if" cümlesinde Past Perfect kullanılır.'
        }
      ]
    }
  },

  'C1-U2-L2': {
    id: 'C1-U2-L2',
    title: 'Regrets About the Past',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Geçmişe Dair Pişmanlıklar',
          explanation: 'Third Conditional genellikle pişmanlık ifade eder. "Should have" ve "Wish" yapıları da kullanılır.',
          table: {
            headers: ['Yapı', 'Örnek', 'Anlam'],
            rows: [
              ['I wish I had + V3', 'I wish I had applied earlier.', 'Keşke daha önce başvursaydım'],
              ['If only I had + V3', 'If only I had been more careful!', 'Keşke daha dikkatli olsaydım!'],
              ['I should have + V3', 'I should have checked twice.', 'İki kez kontrol etmeliydim'],
              ['I shouldn\'t have + V3', 'I shouldn\'t have ignored the warning.', 'Uyarıyı görmezden gelmemeliydin']
            ]
          }
        },
        {
          type: 'vocabulary',
          title: '✈️ Kabin Memuru Pişmanlık İfadeleri',
          words: [
            { en: 'I wish I had noticed the passenger\'s discomfort earlier.', tr: 'Keşke yolcunun rahatsızlığını daha önce fark etseydim.' },
            { en: 'We should have made the announcement sooner.', tr: 'Anonsu daha erken yapmalıydık.' },
            { en: 'If only we had more time to prepare.', tr: 'Keşke hazırlanmak için daha fazla zamanımız olsaydı.' }
          ]
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'I wish I ___ the emergency exit procedures better.',
          options: ['know', 'knew', 'had known', 'have known'],
          correctIndex: 2,
          explanation: '"Wish" + Past Perfect = Geçmişe dair pişmanlık'
        },
        {
          type: 'fillBlank',
          sentences: [
            { text: 'I ___ ___ (should/check) the equipment before takeoff.', answer: 'should have checked' },
            { text: 'If only we ___ ___ (have/more time)!', answer: 'had had' }
          ]
        }
      ]
    }
  },

  'C1-U2-L3': {
    id: 'C1-U2-L3',
    title: 'Mixed Conditionals',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Mixed Conditionals (Karışık Koşullu)',
          explanation: 'Farklı zaman dilimlerini birleştiren koşullu cümleler. Geçmiş → Şimdi veya Şimdi → Geçmiş.',
          table: {
            headers: ['Tip', 'Yapı', 'Örnek'],
            rows: [
              ['Geçmiş → Şimdi', 'If + Past Perfect, would + V1', 'If I had studied medicine, I would be a doctor now.'],
              ['Şimdi → Geçmiş', 'If + Past Simple, would have + V3', 'If I were taller, I would have been accepted.'],
              ['Kullanım', '-', 'Geçmiş bir kararın şimdiki sonucu VEYA şimdiki durumun geçmişteki etkisi']
            ]
          }
        },
        {
          type: 'example',
          title: '✈️ Havacılık Mixed Conditionals',
          items: [
            { en: 'If I had taken the training, I would be a senior cabin crew now.', tr: 'Eğitimi alsaydım şimdi kıdemli kabin memuru olurdum.' },
            { en: 'If she weren\'t afraid of flying, she would have become a pilot.', tr: 'Uçmaktan korkmasaydı pilot olurdu.' },
            { en: 'If I had joined earlier, I would have more experience now.', tr: 'Daha önce katılsaydım şimdi daha fazla deneyimim olurdu.' }
          ]
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'If she ___ harder in training, she ___ a purser now.',
          options: ['worked / would be', 'had worked / would be', 'had worked / would have been', 'works / will be'],
          correctIndex: 1,
          explanation: 'Geçmiş eylem → Şimdiki sonuç için "If + Past Perfect, would + V1" kullanılır.'
        }
      ]
    }
  },

  'C1-U2-L4': {
    id: 'C1-U2-L4',
    title: 'Wish + Past Perfect',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Wish + Past Perfect',
          explanation: 'Geçmişte farklı olmasını istediğimiz durumları ifade eder.',
          table: {
            headers: ['Yapı', 'Örnek', 'Anlam'],
            rows: [
              ['I wish + Past Perfect', 'I wish I had studied harder.', 'Keşke daha çok çalışsaydım'],
              ['I wish + hadn\'t + V3', 'I wish I hadn\'t said that.', 'Keşke onu söylemeseydim'],
              ['She wishes + Past Perfect', 'She wishes she had applied.', 'Keşke başvursaydı']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 "Wish" ile geçmiş pişmanlık = "If only" ile aynı anlam: I wish I had... = If only I had...'
        }
      ],
      exercises: [
        {
          type: 'fillBlank',
          sentences: [
            { text: 'I wish I ___ ___ (prepare) better for the interview.', answer: 'had prepared' },
            { text: 'She wishes she ___ ___ (not/miss) the training session.', answer: 'hadn\'t missed' }
          ]
        }
      ]
    }
  },

  'C1-U2-L5': {
    id: 'C1-U2-L5',
    title: 'Uygulama: Olay Analizi',
    type: 'practice',
    content: {
      sections: [
        {
          type: 'scenario',
          title: '✈️ Olay İnceleme: Kaçırılan Bağlantı',
          dialogues: [
            {
              speaker: 'Yönetici',
              text: 'The passenger missed their connection. What could we have done differently?',
              translation: 'Yolcu bağlantı uçuşunu kaçırdı. Farklı ne yapabilirdik?'
            },
            {
              speaker: 'Kabin Memuru',
              text: 'If we had been informed earlier, we could have arranged priority disembarkation.',
              translation: 'Daha önce bilgilendirilseydik, öncelikli iniş ayarlayabilirdik.'
            },
            {
              speaker: 'Kabin Amiri',
              text: 'I wish we had checked the connection times before landing.',
              translation: 'Keşke inmeden önce bağlantı saatlerini kontrol etseydik.'
            }
          ]
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'If the crew ___ about the tight connection, they ___ the passenger.',
          options: [
            'knew / would help',
            'had known / would have helped',
            'know / will help',
            'had known / helped'
          ],
          correctIndex: 1,
          explanation: 'Third Conditional: If + Past Perfect, would have + V3'
        }
      ]
    }
  },

  'C1-U2-EXAM': {
    id: 'C1-U2-EXAM',
    title: '📝 Ünite 2 Sınavı',
    type: 'exam',
    content: {
      timeLimit: 20,
      passingScore: 80,
      questions: [
        {
          type: 'multipleChoice',
          question: 'If I had known about the delay, I ___ .',
          options: ['will inform you', 'would inform you', 'would have informed you', 'informed you'],
          correctIndex: 2
        },
        {
          type: 'multipleChoice',
          question: 'I wish I ___ the announcement more clearly.',
          options: ['make', 'made', 'had made', 'have made'],
          correctIndex: 2
        },
        {
          type: 'multipleChoice',
          question: 'If she ___ more experience, she ___ a better cabin crew now.',
          options: ['had / would be', 'had had / would be', 'has / will be', 'had / was'],
          correctIndex: 1
        }
      ]
    }
  }
};

export default C1_UNIT_2;
